var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"navbar-banner"},[_c('tags-view',{ref:"tags-view",attrs:{"visited-views":_vm.visitedViews,"cached-views":_vm.cachedViews,"tags-cut":_vm.tagsCut,"all-menu":_vm.allMenu,"all-routes":_vm.allRoutes},on:{"setVisitedView":_vm.setVisitedView,"refreshTagsActions":_vm.refreshTagsActions}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }